function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import UploadDropzone from '../Upload/UploadDropzone';
import LayoutButtons from "../Layout/LayoutButtons";
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    border: "1px solid",
    borderColor: theme.palette.divider,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));

const MediaUpload = (_ref) => {
  let className = _ref.className,
      mediaType = _ref.mediaType,
      buttons = _ref.buttons,
      uploadProgress = _ref.uploadProgress,
      onUpload = _ref.onUpload,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "mediaType", "buttons", "uploadProgress", "onUpload"]);

  const classes = useStyles({
    mediaType
  });

  if (uploadProgress) {
    return React.createElement("div", {
      className: className || classes.root
    }, uploadProgress + "/100");
  }

  if (buttons && buttons.length) {
    buttons = buttons.map((button, index) => {
      if (index > 0) {
        return _extends({}, button, {
          variant: "text",
          color: "inherit"
        });
      }

      return _extends({}, button, {
        variant: "outlined",
        color: "inherit"
      });
    });
    return React.createElement("div", {
      className: className || classes.root
    }, React.createElement(LayoutButtons, _extends({}, props, {
      buttons: buttons
    })));
  }

  return React.createElement(UploadDropzone, _extends({}, props, {
    onUpload: onUpload
  }), React.createElement("div", {
    className: className || classes.root
  }, "Upload media"));
};

export default MediaUpload;